var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChip = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9 2.15c.47 0 .85.38.85.85v1.15h4.3V3a.85.85 0 0 1 1.7 0v1.15H17A2.85 2.85 0 0 1 19.85 7v1.15H21a.85.85 0 0 1 0 1.7h-1.15v4.3H21a.85.85 0 0 1 0 1.7h-1.15V17A2.85 2.85 0 0 1 17 19.85h-1.15V21a.85.85 0 0 1-1.7 0v-1.15h-4.3V21a.85.85 0 0 1-1.7 0v-1.15H7A2.85 2.85 0 0 1 4.15 17v-1.15H3a.85.85 0 0 1 0-1.7h1.15v-4.3H3a.85.85 0 1 1 0-1.7h1.15V7A2.85 2.85 0 0 1 7 4.15h1.15V3c0-.47.38-.85.85-.85m-2 3.7A1.15 1.15 0 0 0 5.85 7v10c0 .635.515 1.15 1.15 1.15h10A1.15 1.15 0 0 0 18.15 17V7A1.15 1.15 0 0 0 17 5.85zM8.15 9c0-.47.38-.85.85-.85h6c.47 0 .85.38.85.85v6c0 .47-.38.85-.85.85H9a.85.85 0 0 1-.85-.85zm1.7.85v4.3h4.3v-4.3z",
  clipRule: "evenodd"
})));
export default SvgChip;